import { platformTypeENUM } from "@config/constants"
import { caseConverters } from "config/utils"
import { FeatureFlagEnums } from "./featureFlags.type"

export interface SDQualificationInterface {
	name: string
	canBeOverRidden: boolean
	siaDetails?: {
		firstName: string
		surname: string
		licenceNumber: string
		role: string
		licenceSector: string
		expiryDate: string
		status: string
		statusExplanation: string
		additionalLicenceConditions: string
	}
}
export interface GetSDQualificationInterface extends SDQualificationInterface {
	_id: string
}
export interface UpdateSDQualificationInterface extends SDQualificationInterface {
	_id: string
}

export interface SDEquipmentTypeInterface {
	description: string
	allocatedToEmployee: boolean
	allocatedToLocation: boolean
}

export interface GetSDEquipmentTypeInterface extends SDEquipmentTypeInterface {
	_id: string
}
export interface UpdateSDEquipmentTypeInterface extends SDEquipmentTypeInterface {
	_id: string
}
export interface SDDocumentTypeInterface {
	type: string
	enabledForLocations: boolean
	enabledForEmployees: boolean
}
export interface GetSDDocumentTypeInterface extends SDDocumentTypeInterface {
	_id: string
}
export interface UpdateSDDocumentTypeInterface extends SDDocumentTypeInterface {
	_id: string
}

export interface SDCountiesInterface {
	name: string
}

export interface GetSDCountiesInterface extends SDCountiesInterface {
	_id: string
}
export interface UpdateSDCountiesInterface extends SDCountiesInterface {
	_id: string
}

export interface SDSuppliersInterface {
	name: string
	company: string
	payCode?: string
}
export interface GetSDSuppliersInterface extends SDSuppliersInterface {
	_id: string
}
export interface UpdateSDSuppliersInterface extends SDSuppliersInterface {
	_id: string
}
export interface SDCompaniesInterface {
	name: string
	employees: string[]
	locations: string[]
	branches: string[]
	customers: string[]
	suppliers: string[]
}
export interface GetSDCompaniesInterface extends SDCompaniesInterface {
	_id: string
}
export interface UpdateSDCompaniesInterface extends SDCompaniesInterface {
	_id: string
}
export interface SDBillGroupInterface {
	name: string
}
export interface GetSDBillGroupInterface extends SDBillGroupInterface {
	_id: string
}
export interface UpdateSDBillGroupInterface extends SDBillGroupInterface {
	_id: string
}

export interface SDIncidentsInterface {
	name: string
	description: string
	defaultEscalationType: string
	priority: string
	shownInWorkMonitor: boolean
	isCompanyWide: boolean
	isDescriptionRequired: boolean
	isEnabled: boolean
}
export interface GetSDIncidentsInterface extends SDIncidentsInterface {
	_id: string
}
export interface UpdateSDIncidentsInterface extends SDIncidentsInterface {
	_id: string
}

export interface SDEventTypes {
	_id: string
	name: string
	description: string
	scheduledToEmployee: boolean
	scheduledToPost: boolean
	countedAs: SDEventTypesCountedAs
	resultsInPay: boolean
	resultsInBill: boolean
	isEnabled: boolean
}

export enum SDEventTypesCountedAs {
	"WORK" = "WORK",
	"TRAINING" = "TRAINING",
	"SICKNESS" = "SICKNESS",
	"HOLIDAY" = "HOLIDAY",
	"NONE" = "NONE",
}

export const SDEventTypesCountAsOptions = Object.values(SDEventTypesCountedAs).map(item => ({
	label: caseConverters.titleCase(item),
	value: item,
}))

export interface AdminQueryParams {
	tab: string
	platform: platformTypeENUM
	selected: string
}

export enum ADMIN_STATIC_DATA_TABS {
	COMPANIES = "companies",
	BRANCHES = "branches",
	CUSTOMERS = "customers",
	SUPPLIERS = "suppliers",
	NOTIFICATIONS = "notifications",
	QUALIFICATIONS = "qualifications",
	EQUIPMENT_TYPES = "equipment_types",
	COUNTIES = "counties",
	INCIDENTS = "incidents",
	PAY_GROUPS = "pay_groups",
	EVENT_TYPES = "event_types",
}

export interface AdminStaticDataOptions {
	label: string
	component: React.ReactNode
	perform: string | string[]
	featureName: FeatureFlagEnums
	value: ADMIN_STATIC_DATA_TABS
}
